import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { ArrowPathIcon, Button } from "~/ui";
import { SearchInput } from "~/ui/SearchInput";

interface FileManagerTableFilterProps {
  setSearchText: (value: string) => void;
}

export const FileManagerTableFilter = ({
  setSearchText,
}: FileManagerTableFilterProps) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await queryClient.invalidateQueries({
        queryKey: ["getFileManager"],
      });
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <div className="flex items-center justify-between">
      <SearchInput
        onValueChange={setSearchText}
        placeholder={t("file_manager.search_placeholder")}
      />
      <Button
        onClick={handleRefresh}
        variant="outline"
        color="primary"
        text={t("general.refresh")}
        className="ml-4 flex items-center gap-2"
        leftIcon={
          <ArrowPathIcon
            className={`h-5 w-5 text-primary-50 dark:text-primary-80 ${isRefreshing ? "animate-spin" : ""}`}
          />
        }
        disabled={isRefreshing}
      />
    </div>
  );
};
